import styled from 'styled-components';

export const Section = styled.section`
  max-width: 1200px;
  width: 95%;
  margin: 0 auto 16px;
  direction: rtl;

  @media (max-width: 768px) {
    width: 90%;
  }
`;

export const Header = styled.div`
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const Title = styled.p`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 3px 0;
  color: #000000;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  width: 100%;
  justify-content: center;

  &::before,
  &::after {
    content: '';
    flex: 1 1 0;
    min-width: 12px;
    max-width: 160px;
    height: 1px;
    background: oklch(0.9288 0.0126 255.51);
    margin-top: 1px;
  }
`;

export const Subtitle = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  color: oklch(0.68 0.03 257);
  max-width: min(520px, 100%);
  text-align: center;
`;

export const Grid = styled.div<{ $count: number }>`
  display: grid;
  grid-template-columns: repeat(${p => Math.min(p.$count, 4)}, 1fr);
  gap: 8px;

  @media (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const AppCard = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px 12px 12px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid oklch(0.93 0.01 255);
  text-decoration: none;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;

  &:hover {
    border-color: var(--primary-color, oklch(0.65 0.24 33.09));
    background: oklch(0.995 0.002 248);
  }

  &:focus-visible {
    outline: none;
    border-color: var(--primary-color, oklch(0.65 0.24 33.09));
    box-shadow: 0 0 0 3px oklch(0.65 0.24 33.09 / 0.12);
  }
`;

export const AppLogoBox = styled.span`
  width: 100%;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  @media (max-width: 480px) {
    height: 44px;
  }
`;

export const AppLogo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
`;

export const AppName = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: oklch(0.5 0.03 257);
  text-align: center;
  line-height: 1.2;

  @media (max-width: 480px) {
    font-size: 11px;
  }
`;

export const AppCta = styled.span``;

// ==================== Skeleton Styles ====================

const shimmer = `
  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

export const SkeletonBase = styled.div`
  ${shimmer}
  background: linear-gradient(
    90deg,
    oklch(0.9683 0.0069 247.9) 0%,
    oklch(0.9288 0.0126 255.51) 20%,
    oklch(0.9683 0.0069 247.9) 40%,
    oklch(0.9683 0.0069 247.9) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s ease-in-out infinite;
  border-radius: 4px;
`;

export const SkeletonTitle = styled(SkeletonBase)`
  width: 120px;
  height: 14px;
  border-radius: 4px;
`;

export const SkeletonCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px 12px 12px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid oklch(0.93 0.01 255);
`;

export const SkeletonLogo = styled(SkeletonBase)`
  width: 100%;
  height: 52px;
  border-radius: 8px;

  @media (max-width: 480px) {
    height: 44px;
  }
`;

export const SkeletonName = styled(SkeletonBase)`
  width: 55px;
  height: 11px;
  border-radius: 4px;
`;
